import { Injectable } from "@angular/core";

@Injectable()
export class AppSettings {
  public clientId = 1;
  public authTokenKey = 'auth_token';
  public authPrefix = 'Bearer ';
}
